__turbopack_context__.v({
  "break": "FindACar-module-scss-module__AygUQW__break",
  "footer": "FindACar-module-scss-module__AygUQW__footer",
  "header": "FindACar-module-scss-module__AygUQW__header",
  "root": "FindACar-module-scss-module__AygUQW__root",
});
